import { all } from "redux-saga/effects";

import Auth from "./auth";
import Me from "./me";
import Pages from "./pages";
import Faq from "./faq";
import Newsletter from "./newsletter";
import Artist from "./artist";
import Space from "./space";
import Team from "./team";
import Blog from "./blog";
import OpenCalls from "./openCalls";
import Events from "./events";
import Lessons from "./lessons";
import Search from "./search";
import Tickers from "./tickers";
import SpaceReservations from "./spaceReservations";

export default function* rootSaga() {
    yield all([
        Auth(),
        Me(),
        Faq(),
        Artist(),
        Space(),
        Team(),
        Pages(),
        Newsletter(),
        Blog(),
        OpenCalls(),
        Events(),
        Lessons(),
        Search(),
        Tickers(),
        SpaceReservations(),
    ]);
}
